var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFilter = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#4C4C4C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77427 11.5057C9.96316 11.7112 10.0669 11.9798 10.0669 12.2575V20.4428C10.0669 20.9354 10.6613 21.1854 11.0132 20.8391L13.2965 18.2224C13.6021 17.8558 13.7706 17.6743 13.7706 17.3113V12.2594C13.7706 11.9816 13.8762 11.7131 14.0632 11.5075L20.6151 4.39817C21.1059 3.86483 20.7281 3 20.0022 3H3.8353C3.10936 3 2.72973 3.86297 3.22233 4.39817L9.77427 11.5057Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFilter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Filter.611b871412c52e4a1016459dc4e0bcbc.svg";